import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const F = ({ id, label, value, onChange, placeholder, type = 'text' }) => (
  <div>
    <Label htmlFor={id}>{label}</Label>
    <Input id={id} data-testid={id} value={value ?? ''} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} type={type} />
  </div>
);

const YachtForm = ({ details, onChange }) => {
  const set = (k, v) => onChange({ ...details, [k]: v });
  return (
    <div className="space-y-4" data-testid="yacht-form">
      <div className="grid grid-cols-2 gap-3">
        <F id="ca-y-name" label="Vessel name" value={details.vessel_name} onChange={(v) => set('vessel_name', v)} placeholder='e.g. "Sea Breeze"' />
        <F id="ca-y-length" label="Length (metres)" value={details.length_metres} onChange={(v) => set('length_metres', v ? Number(v) : null)} placeholder="e.g. 32" type="number" />
      </div>
      <div className="grid grid-cols-3 gap-3">
        <F id="ca-y-manufacturer" label="Builder / manufacturer" value={details.manufacturer} onChange={(v) => set('manufacturer', v)} placeholder="e.g. Sunseeker" />
        <F id="ca-y-model" label="Model" value={details.model} onChange={(v) => set('model', v)} placeholder="e.g. 100 Yacht" />
        <F id="ca-y-year" label="Year built" value={details.year} onChange={(v) => set('year', v)} placeholder="2020" type="number" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <F id="ca-y-reg" label="Registration number" value={details.registration_number} onChange={(v) => set('registration_number', v)} placeholder="Vessel registration" />
        <F id="ca-y-flag" label="Flag country" value={details.flag_country} onChange={(v) => set('flag_country', v)} placeholder="e.g. Cayman Islands" />
      </div>
      <div>
        <Label htmlFor="ca-y-ownership">Ownership type</Label>
        <Select value={details.ownership_type || ''} onValueChange={(v) => set('ownership_type', v)}>
          <SelectTrigger id="ca-y-ownership" data-testid="ca-y-ownership"><SelectValue placeholder="Pick one" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="owned">Owned outright</SelectItem>
            <SelectItem value="financed">Financed</SelectItem>
            <SelectItem value="fractional">Fractional / shared</SelectItem>
            <SelectItem value="chartered_out">Chartered out</SelectItem>
          </SelectContent>
        </Select>
      </div>
      {details.ownership_type === 'financed' && (
        <div className="grid grid-cols-2 gap-3">
          <F id="ca-y-lender" label="Lender" value={details.lender_name} onChange={(v) => set('lender_name', v)} placeholder="e.g. Credit Suisse Marine" />
          <F id="ca-y-balance" label="Outstanding balance" value={details.loan_balance} onChange={(v) => set('loan_balance', v ? Number(v) : null)} placeholder="0" type="number" />
        </div>
      )}
      {details.ownership_type === 'fractional' && (
        <F id="ca-y-fractional-share" label="Share owned (%)" value={details.fractional_share} onChange={(v) => set('fractional_share', v ? Number(v) : null)} placeholder="e.g. 25" type="number" />
      )}
      <div className="grid grid-cols-2 gap-3">
        <F id="ca-y-marina" label="Marina / berth location" value={details.marina_location} onChange={(v) => set('marina_location', v)} placeholder="e.g. Port Hercule, Monaco" />
        <F id="ca-y-management" label="Management company" value={details.management_company} onChange={(v) => set('management_company', v)} placeholder="e.g. Camper & Nicholsons" />
      </div>
      <div className="grid grid-cols-2 gap-3">
        <F id="ca-y-insurance" label="Insurance policy" value={details.insurance_reference} onChange={(v) => set('insurance_reference', v)} placeholder="Insurer / policy #" />
        <F id="ca-y-captain" label="Captain contact" value={details.captain_contact} onChange={(v) => set('captain_contact', v)} placeholder="Name and phone / email" />
      </div>
    </div>
  );
};

export default YachtForm;
